export const RECORD_GET_LIST_ACTION = "RECORD_GET_LIST"
export const RECORD_SAVE_ACTION = "RECORD_SAVE"
export const RECORD_SHOW_ACTION = "RECORD_SHOW"
export const RECORD_DELETE_ACTION = "RECORD_DELETE"
export const RECORD_APPROVE_ACTION = "RECORD_APPROVE"
export const RECORD_DENY_ACTION = "RECORD_DENY"
